const routes = {
  editAlunoFotoPath: id => `${RELATIVE_URL_PATH}/alunos/${id}/foto`,
  queryLaboratoriosPath: params => `${RELATIVE_URL_PATH}/query_laboratorios?${new URLSearchParams(params).toString()}`,
  queryProgramasPath: params => `${RELATIVE_URL_PATH}/query_programas?${new URLSearchParams(params).toString()}`,
  queryCursosPath: params => `${RELATIVE_URL_PATH}/query_cursos?${new URLSearchParams(params).toString()}`,
  querylinhasDePesquisaPath: () => `${RELATIVE_URL_PATH}/query_linhas_de_pesquisa`,
};

export { routes };
